import { useCallback, useEffect, useMemo, useState } from 'react';
import type { MapMarker } from '@/utils/dashboardMap';
import { getMapMarkerKey } from '@/utils/dashboardMap';

export function useActiveMapMarker(markers: MapMarker[]) {
  const [activeKey, setActiveKey] = useState<string | null>(null);

  const activeMarker = useMemo(
    () => markers.find((marker) => getMapMarkerKey(marker) === activeKey) ?? null,
    [markers, activeKey],
  );

  useEffect(() => {
    if (markers.length === 0) {
      setActiveKey(null);
      return;
    }

    const hasActive =
      activeKey !== null && markers.some((marker) => getMapMarkerKey(marker) === activeKey);
    if (!hasActive) {
      setActiveKey(getMapMarkerKey(markers[0]));
    }
  }, [markers, activeKey]);

  const selectMarker = useCallback((marker: MapMarker) => {
    setActiveKey(getMapMarkerKey(marker));
  }, []);

  const selectMarkerByKey = useCallback((key: string) => {
    setActiveKey(key);
  }, []);

  return {
    activeMarker,
    activeKey,
    selectMarker,
    selectMarkerByKey,
  };
}
